export default {
	personalCenter: {
		vip_member: 'VIP 회원',
		vip: {
			level_label: 'VIP{level} 등급', next_level: '다음 등급: VIP{level}',
			points_summary: '현재 {current} 포인트, VIP{level}까지 {remaining} 포인트 남음',
			level_rewards: '등급 보상', reward_title: 'VIP{level} 보상', exclusive_rewards: '전용 보상', promotion_reward: 'VIP{level} 승급 보상',
			previous_level: '이전 등급', next_level_button: '다음 등급',
			dragon_key: '용혼 열쇠 ×{count}', battle_shard: '전문 조각 ×{count}', forge_crystal: '단조 결정 ×{count}',
			unlocked: 'VIP{level} 달성, 지금 수령할 수 있습니다.', locked: 'VIP{level}을 아직 달성하지 못했습니다.',
			claim: '수령', claiming: '수령 중...', claimed: '수령 완료', claim_success: 'VIP{level} 보상을 수령했습니다', claim_failed: '보상 수령에 실패했습니다. 잠시 후 다시 시도하세요.',
			points_label: '포인트', go_redeem: '교환하기',
			experience_summary: '현재 경험치 {current}; VIP{level}까지 {remaining} 경험치 남음',
			max_level: '최고 등급 달성!', current_experience: '현재 경험치 {current}'
		},
		title: '개인 센터', my_exchange: '내 교환 내역', my_points: '내 포인트', lottery_records: '추첨 기록', recharge_records: '충전 기록',
		redeem_gift: '선물 교환', redeem_description: '교환 코드를 입력하면 선택한 캐릭터로 보상이 지급됩니다.', redeem_code: '교환 코드', redeem_code_placeholder: '교환 코드를 입력하세요', redeeming: '교환 중...', redeem_now: '지금 교환', rebate_coupon: '{percent}% 리베이트 쿠폰',
		points_details: '포인트 내역', exchange_time: '교환 시간', reward_content: '보상 내용', status: '상태', time: '시간', type: '유형', points_change: '포인트 변동', balance: '잔액', lottery_time: '추첨 시간', reward: '보상',
		order_id: '주문 번호', payment_channel: '결제 수단', amount: '금액', server: '서버', role: '캐릭터', payment_time: '결제 시간', copy: '복사',
		loading: '불러오는 중...', no_records: '일치하는 기록이 없습니다', no_content: '표시할 내용이 없습니다.', previous: '이전', next: '다음', page_info: '{current} / {total} 페이지',
		source_recharge_reward: '충전 보상', source_official_activity: '공식 이벤트', source_item_exchange: '아이템 교환',
		exchange_success: '교환 성공', exchange_failed: '교환 실패', enter_redeem_code: '교환 코드를 입력하세요', exchange_retry: '교환에 실패했습니다. 잠시 후 다시 시도하세요.',
		copy_success: '복사되었습니다', copy_failed: '복사 실패', lottery_load_failed: '추첨 기록을 불러오지 못했습니다', lottery_load_retry: '추첨 기록을 불러오지 못했습니다. 잠시 후 다시 시도하세요.',
		recharge_load_failed: '충전 기록을 불러오지 못했습니다', recharge_load_retry: '충전 기록을 불러오지 못했습니다. 잠시 후 다시 시도하세요.', points_load_failed: '포인트 기록을 불러오지 못했습니다', points_load_retry: '포인트 기록을 불러오지 못했습니다. 잠시 후 다시 시도하세요.',
		exchange_records_load_failed: '교환 기록을 불러오지 못했습니다', exchange_records_load_retry: '교환 기록을 불러오지 못했습니다. 잠시 후 다시 시도하세요.'
	},
	member_popup: {
		title: '회원 포인트가 추가되었습니다!',
		message: '이번 충전으로 {points} 포인트를 획득했습니다. VIP{nextLevel}까지 {remaining} 포인트 남았습니다.',
		progress: '누적 충전 포인트 {current} / {target}',
		next: 'VIP{nextLevel}까지 {remaining} 포인트',
		suppress: '7일간 다시 표시하지 않기',
		later: '나중에',
		rewards: '보상 받으러 가기',
		close: '회원 알림 닫기'
	},
	member_level: {
		title: '회원 등급',
		points_progress: '누적 충전 포인트',
		next_level: 'VIP{level} 승급까지',
		points_unit: '포인트',
		view_rewards: '등급 보상 보기'
	},
	login_button_text: '로그인',
	logining_button_text: '로그인',
	account_input_text: '메일 주소를 입력하세요',
	password_input_text: '비밀번호를 입력하세요',
	other_login_methods_text: '기타 로그인 방식',
	top_up_center_text: '충전 센터',
	benefit_text: '혜택',
	sign_in_text: '로그인',
	log_out_text: '로그아웃',
	service_terms_text: '이용 약관',
	privacy_policy_text: '개인정보 처리방침',
	official_apk_download_text: '공식 APK 버전 다운로드',
	official_facebook_text: '공식 라운지',
	recharge_instructions_text: '충전 안내',
	rebate_countdown_title: '한정 페이백 진행 중',
	rebate_countdown_label: '카운트다운',
	rebate_countdown_days: '일',
	rebate_countdown_hours: '시간',
	rebate_countdown_minutes: '분',
	rebate_countdown_seconds: '초',
	log_in_game_account_text: '계정 로그인하세요',
	sign_in_lowercase_text: '로그인',
	instructions_text: '안내',
	confirm_text: '확인 ',
	cancel_text: '취소',
	switch_character_text: '캐릭터 전환',
	copy_successful_text: '복제 성공',
	claimed_text: '수령 완료',
	claim_success_text: '수령 성공',
	claim_text: '수령',
	claim_unmet_text: '조건 미충족',
	contact_customer_service_text: '고객센터 문의하기',
	home_page_text: '메인 화면',
	payment_successful_text: '결제 성공',
	purchase_confirm_text: '구매 확인',
	payment_channels_text: '결제 채널',
	payment_button_text: '구매',
	original_price_text: '기본 가격',
	discounts_text: '할인',
	earn_points_text: '포인트 획득',
	rebates_text: '페이백',
	amount_text: '가격',
	insufficient_points_text: '포인트 부족',
	insufficient_lottery_count_text: '추첨 횟수 부족',
	network_error_retry_text: '네트워크 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
	score_lottery_text: '포인트 추첨',
	score_lottery_entrance_error: '포인트 추첨 입장 데이터 요청 오류:',
	lottery_current_points_label: '현재 적립금:',
	lottery_points_recharge_tip: '적립금은 충전을 통해 획득할 수 있습니다.',
	lottery_spin_label: '룰렛 추첨',
	lottery_rule_button: '규칙 상세',
	lottery_rule_popup_title: '이벤트 규칙',
	lottery_record_button: '당첨 기록 조회',
	lottery_record_title: '당첨 기록',
	lottery_record_empty: '기록 없음',
	lottery_record_time: '시간',
	lottery_record_prize: '상품 내용',
	lottery_daily_limit: '오늘 한도 도달',
	lottery_remaining_count: '남은 횟수 {count}',
	lottery_draw_cost: '{cost} 점',
	lottery_init_data_error: '포인트 추첨 데이터 요청 오류:',
	daily_rewards_text: '매일 보상',
	points_text: '포인트 상점',
	winning_award_text: "수상 축하합니다.",
	points_limit_tips_text: "해당 보상은 이미 수령 완료되었으니 보상 수령 쿨다임 시간 끝난 후 다시금 교환해 보세요~",
	receive_reward_tips_text: "보상은 이미 당신의 캐릭터의 이메일로 발송, 당신의 캐릭터에 로그인하여 수령하세요!",
	hot_title_text: "충전 상점",
	other_title_text: "패키지 상점",
	limit_title_text: "한정 구매",
	limit_text: "한정 구매",
	sell_out_text: "매진",
	copy_fail_text: "복사 실패",
	payment_type_text: "결제 수단",
	order_id_text: "주문 번호",
	payment_time_text: "결제 시간",
	copy_text: "복사",
	amount_text: "금액",
	game_server_text: "서버",
	game_role_text: "캐릭터",
	orders_records_text: "충전 내역",
	no_data_text: '데이터 없음',
	orders_tips_text: "시스템 설정에 따라 최근 30일간의 충전 내역만 조회 가능합니다",
	pointsDescribeText: '공식 웹사이트에 충전하시면 포인트를 적립할 수 있으며 포인트상점에서 희귀 아이템 교환이 가능합니다.',
	pointsBalanceText: '보유 포인트',
	points_period_daily: '오늘',
	points_period_week: '이번주',
	points_period_month: '이번달',
	points_period_lifetime: '평생',
	points_tag_mustBuy: '필수 구매',
	points_tag_selected: '엄선',
	points_tag_discount: '할인',
	points_tag_perk: '혜택',
	coupon: {
		discount_label: '페이백',
		title_html: '페이백 쿠폰을 사용하여 구매 후 <br/>페이백 획득 가능합니다.',
		expired_text: '유효 기간 만료',
		used_text: '사용 완료',
		countdown_prefix: '카운트다운',
		activity_button_text: '페이백 쿠폰 추첨'
	},
	pagination: {
		previous: "이전",
		next: "다음",
		page_info: "페이지 {current} / {total}"
	},
	// Support
	support_my_questions: '내 문의',
	support_submit_issue: '문의 제출',
	support_records_title: '내 문의 기록',
	support_records_desc: '처리 진행 상황을 확인하고 정보를 추가할 수 있습니다.',
	support_refresh: '새로고침',
	support_tabs_label: '고객지원 탭',
	support_load_more: '더 보기',
	support_user_id: '사용자 ID',
	support_game: '게임',
	support_platform: '플랫폼',
	support_back: '뒤로',
	support_mark_solved: '해결됨',
	support_official_support: '공식 고객지원',
	support_image: '이미지',
	support_reply_hint: '추가 내용이 고객지원팀에 전송됩니다',
	support_send: '전송',
	support_sending: '전송 중...',
	support_player: '플레이어',
	support_attachment_preview: '첨부파일 미리보기',
	support_remove_attachment: '첨부파일 삭제',
	support_attachment_fallback: '첨부파일',
	support_survey_title: '설문 안내',
	support_survey_message: '문제가 해결되었나요?',
	support_survey_close: '닫기',
	support_submit_success: '제출 성공',
	support_submit_fail: '제출 실패',
	support_close_success: '채팅이 종료되었습니다',
	support_close_fail: '종료 실패',
	support_rate_title: '이번 응대에 대해 평가해주세요',
	support_input_placeholder: '내용을 입력하세요...',
	support_image_pick_error: '이미지 경로를 가져오지 못했습니다',
	support_send_fail: '전송 실패',
	support_evaluate_success: '평가 성공',
	support_evaluate_fail: '평가 실패',
	support_status_unreplied: '미응답',
	support_status_replied: '응답 완료',
	support_status_resolved: '해결됨',
	support_status_pending_review: '평가 대기',
	support_form_type_label: '문의 유형',
	support_form_type_placeholder: '문의 유형을 선택하세요',
	support_form_desc_label: '문의 내용',
	support_form_desc_placeholder: '문제를 자세히 설명해주세요...',
	support_form_upload_label: '첨부파일',
	support_form_upload_click: '파일 업로드',
	support_form_upload_tips: '(이미지 10MB 이하, 영상 50MB 이하, 최대 5개)',
	support_form_submit: '제출',
	support_form_image_too_big: '이미지는 10MB를 초과할 수 없습니다',
	support_form_video_too_big: '영상은 50MB를 초과할 수 없습니다',
	support_type_topup: '충전 문제',
	support_type_account: '계정 문제',
	support_type_guide: '게임 가이드',
	support_type_suggestion: '의견 제안',
	support_type_event: '이벤트 문제',
	support_type_report: '위반 신고',
	support_type_other: '기타',
	support_type_topup_hint: '충전 미도착, 금액 오류',
	support_type_account_hint: '로그인, 차단, 연동 문제',
	support_type_guide_hint: '플레이, 퀘스트, 진행도 문제',
	support_type_suggestion_hint: '피드백 및 제안',
	support_type_report_hint: '부정행위, 욕설, 위반 신고',
	support_type_other_hint: '기타 미분류 문제',
	support_type_topup_code: 'Pay',
	support_type_account_code: 'Acc',
	support_type_guide_code: 'Tip',
	support_type_suggestion_code: 'Idea',
	support_type_report_code: 'Rpt',
	support_type_other_code: 'Etc',
	support_submitting: '제출 중...',
	couponLottery: {
		rules_btn: '이용 규칙',
		daily_draw_title: '매일 페이백 쿠폰 추첨',
		unlocked_extra: '남은 횟수: {amount}회',
		draws_used_up: '오늘의 추첨 기회를 모두 사용했습니다',
		unlock_extra_tip: '오늘 ${amount} 충전 시 추가 추첨 기회가 해제됩니다!',
		tab_lucky_draw: '행운의 대박 추첨',
		tab_my_coupons: '내 쿠폰',
		current_pool: '현재 추첨 풀(오늘 참여 완료)',
		current_pool_not: '현재 추첨 풀(오늘 미참여)',
		unit_people: '명',
		next_draw: '다음 추첨 시간',
		tomorrow: '내일',
		countdown_prefix: '추첨까지: ',
		reward_info: '보상 정보',
		reward_label: '보상:',
		winners_label: '당첨 인원:',
		max_use_label: '최대 사용 가능 금액:',
		validity_label: '쿠폰 유효 기간:',
		unit_piece: '장',
		recharge_amount: '${amount} 충전',
		validity_hours: '획득 후 {hours}시간',
		participation_rules: '참여 규칙',
		rule_1: '당일 공식 웹사이트에서 금액에 관계없이 충전하면 자동으로 추첨 풀에 참여합니다',
		rule_2: '추첨 풀 참여자가 10명 이상일 때 추첨이 진행되며, 조건 충족 시 다음 날 오전 10시에 당첨자를 발표합니다',
		rule_3: '당첨 보상은 50% 페이백 쿠폰이며, $49.99 이하 충전에만 사용할 수 있습니다',
		rule_4: '자세한 이벤트 규칙은 오른쪽 상단의 이용 규칙에서 확인할 수 있습니다',
		view_results_now: '지금 당첨 결과 확인',
		recent_winners: '최근 당첨자 명단',
		player_name: '플레이어 이름',
		redeem_code_title: '교환 코드 등록',
		redeem_code_sub: '교환 코드를 입력하면 전용 페이백 쿠폰을 받을 수 있습니다',
		redeem_code_placeholder: '교환 코드를 입력하세요',
		redeem_btn: '교환',
		redeem_tip: '교환 코드는 대소문자를 구분하므로 표기된 그대로 입력해 주세요. 각 코드는 한 번만 사용할 수 있으며, 교환에 성공한 페이백 쿠폰은 계정에 자동 지급됩니다.',
		available_coupons: '사용 가능한 페이백 쿠폰 ({count})',
		rebate_coupon: '페이백 쿠폰',
		remaining_time: '남은 시간',
		obtained_at: '획득 시간:',
		status_available: '사용 가능',
		limit_use: '(${amount} 이하에만 사용 가능)',
		popup_draw_title: '페이백 쿠폰 추첨',
		popup_draw_sub: '지금 행운을 확인해 보세요!',
		popup_confirm: '확인',
		popup_probs_title: '확률 안내',
		popup_prob: '{label}% 페이백 쿠폰: {value}%',
		result_congrats: '축하합니다! <span class="highlight">{percent}</span> 페이백 쿠폰을 획득했습니다!',
		result_validity: '획득 후 {hours}시간 이내 사용 가능',
		confirm: '확인',
		lose_title: '꽝',
		lose_main: '아쉽게도 이번 추첨에서는 당첨되지 않았습니다',
		lose_sub: '내일 다시 도전해 보세요!',
		win_title: '당첨을 축하합니다!',
		win_main: '{percent} 페이백 쿠폰을 획득했습니다!',
		win_sub: '${amount} 이하에 사용 가능, 유효 기간 {hours}시간',
		rules_popup_title: '규칙 안내',
		rules_rebate_title: '페이백 안내',
		rules_rebate_base_title: '1. 기본 페이백 (고정 10%)',
		rules_rebate_base_desc: '공식 웹사이트에서 금액에 관계없이 충전하면 10% 추가 보상을 즉시 받을 수 있습니다.',
		rules_rebate_base_example: '예시: 성주 코인 100개를 충전하면 실제로 성주 코인 110개가 지급됩니다.',
		rules_rebate_draw_title: '2. 페이백 쿠폰 추첨 (10%~30% 쿠폰 무작위 획득)',
		rules_rebate_draw_desc_1: '추첨을 통해 페이백 쿠폰을 획득할 수 있으며, 쿠폰의 페이백 비율은 기본 페이백에 추가로 적용됩니다.',
		rules_rebate_draw_desc_2: '총 페이백 한도는 40%(기본 10% + 쿠폰 최대 30%)입니다.',
		rules_rebate_draw_example: '예시: 성주 코인 100개를 충전하면서 30% 페이백 쿠폰을 사용한 경우, 최종 지급량은 100 x (1 + 기본 10% + 쿠폰 30%) = 성주 코인 140개(총 페이백 40%)입니다.',
		rules_chance_title: '추첨 기회 획득',
		rules_chance_login_desc: '매일 로그인 보상: 매일 처음 공식 웹사이트에 로그인하면 무료 추첨 기회 1회가 지급됩니다.',
		rules_chance_recharge_title: '충전 추가 보상: 하루 누적 충전 금액이 다음 기준에 도달하면 추가 추첨 기회가 해제됩니다(매일 최대 3회):',
		rules_chance_recharge_item_1: '$1600 충전 -> 추가 추첨 1회',
		rules_chance_recharge_item_2: '$2580 충전 -> 추가 추첨 2회',
		rules_chance_recharge_item_3: '$3200 충전 -> 추가 추첨 3회',
		rules_chance_limit: '하루 추첨 횟수는 최대 4회(무료 1회 + 추가 최대 3회)입니다.',
		rules_chance_rates_title: '추첨 확률:',
		rules_chance_rate_10: '10% 페이백 쿠폰: 74%',
		rules_chance_rate_15: '15% 페이백 쿠폰: 15%',
		rules_chance_rate_20: '20% 페이백 쿠폰: 8%',
		rules_chance_rate_25: '25% 페이백 쿠폰: 10%',
		rules_chance_rate_30: '30% 페이백 쿠폰: 3%',
		rules_chance_rate_50: '50% 페이백 쿠폰: 5%',
		rules_usage_title: '페이백 쿠폰 사용',
		rules_usage_item_1: '페이백 쿠폰의 유효 기간은 획득 시점부터 24시간입니다. 기간 내에 사용해 주세요.',
		rules_usage_item_2: '페이백 쿠폰은 공식 웹사이트 직접 충전에만 사용할 수 있으며, 제3자 대리 충전이나 기프트 카드에는 적용되지 않습니다.',
		rules_usage_item_3: '공식 웹사이트의 패키지 상품에는 페이백 쿠폰을 사용할 수 없습니다.',
		rules_usage_item_4: '고액 송금은 해당 페이백 이벤트 대상에서 제외됩니다.',
		rules_activity_title: '《행운의 대박 추첨》 이벤트 규칙',
		rules_activity_slogan: '매일 공식 웹사이트에서 충전하고 대박 추첨에 도전하세요! 행운의 주인공은 바로 당신입니다!',
		rules_activity_qual_title: '【참여 자격】',
		rules_activity_qual_item_1: '이벤트 기간 중 매일 00:00~23:59(UTC+8)에 공식 웹사이트에서 금액에 관계없이 제3자 결제 충전을 완료해야 합니다.',
		rules_activity_qual_item_2: '조건을 충족한 플레이어는 별도 신청 없이 당일 추첨 풀에 자동 등록됩니다.',
		rules_activity_mech_title: '【추첨 방식】',
		rules_activity_mech_item_1: '추첨 시간: 매일 오전 10:00(UTC+8)',
		rules_activity_mech_item_2: '추첨 대상: 전일 00:00~23:59(UTC+8) 사이 공식 웹사이트에서 충전한 플레이어',
		rules_activity_mech_item_3: '추첨 조건: 당일 추첨 풀 참여자가 10명 이상이어야 합니다. 기준 인원에 미달하면 해당 일자의 추첨은 취소되며 추가 추첨은 진행되지 않습니다.',
		rules_activity_mech_item_4: '당첨자 명단: 추첨 풀 화면에서 매일 당첨자 명단을 확인할 수 있습니다.',
		rules_activity_reward_title: '【보상 내용】',
		rules_activity_reward_item: '50% 페이백 쿠폰 x1',
		rules_activity_reward_usage_title: '【50% 페이백 쿠폰 사용 규칙】',
		rules_activity_reward_usage_item_1: '사용 범위: 최대 $49.99(NT$1,690) 충전 상품에 사용 가능',
		rules_activity_reward_usage_item_2: '사용 방법: 충전 시 쿠폰을 선택하면 화면의 페이백 비율에 50%가 자동으로 추가됩니다. 이 상태에서 결제하면 50% 페이백을 받을 수 있습니다.',
		rules_activity_reward_usage_item_3: '유효 기간: 획득 후 24시간 이내에 사용해야 하며, 기간이 지나면 무효가 됩니다.',
		rules_activity_reward_usage_item_4: '유의 사항: 각 충전 건당 쿠폰 1장만 사용할 수 있으며 다른 페이백 쿠폰과 함께 사용할 수 없습니다. 당일 충전한 플레이어는 충전 횟수와 관계없이 하루 1회만 추첨 자격이 인정되며 자격은 누적되지 않습니다.',
		rules_activity_notes_title: '【유의 사항】',
		rules_activity_notes_item_1: '본 이벤트는 공식 웹사이트의 제3자 결제 충전에만 적용되며 게임 내 충전은 제외됩니다.',
		rules_activity_notes_item_2: '악의적인 충전 후 환불, 허위 충전 등 위반 행위가 확인되면 이벤트 자격이 취소되고 지급된 보상이 회수됩니다.',
		rules_activity_notes_item_3: '본 이벤트의 최종 해석권은 운영팀에 있습니다.',
		time_h_m: '{hours}시간 {minutes}분',
		time_h_m_s: '{hours}시간 {minutes}분 {seconds}초',
		coupon_alt: '쿠폰',
		rebate_coupon_with_value: '{percent}% 페이백 쿠폰',
		banner_title: '행운의 페이백',
		banner_subtitle: 'Lucky Payback',
		msg_5003: '아직 추첨 시간이 아닙니다!',
		msg_5004: '당첨되지 않았습니다!',
		msg_3003: '어제 추첨 풀에 참여하지 않았습니다!',
		msg_3004: '추첨 인원이 부족합니다!',
		msg_1000: '당첨을 축하합니다!',
		btn_check_result: '지금 당첨 결과 확인',
		btn_not_participated: '어제 추첨 풀 미참여',
		btn_won: '당첨을 축하합니다',
		btn_not_won: '추첨 결과: 꽝',
		btn_insufficient_participants: '어제 참여 인원 부족',
		exchange_success: '교환에 성공했습니다!',
		exchange_failed: '교환에 실패했습니다. 잠시 후 다시 시도해 주세요.'
	},
	rebate_limited_text: '🔥 한정 {pct}% 페이백',
	rebate_percent_text: '{pct}% 페이백',
	coupon_booster_label: '페이백 추가 쿠폰',
	coupon_expires_after: '{time} 후 만료',
	coupon_threshold_shortfall: '{amount} 더 구매 시 사용 가능',
	coupon_product_excluded: '이 상품에는 사용할 수 없습니다',
	coupon_channel_restricted: '{channels} 결제에서만 사용 가능',
	coupon_unavailable_title: '사용할 수 없는 쿠폰',
	coupon_skip_text: '쿠폰 미사용',
	coupon_count_unit: '장',
	coupon_picker_title: '쿠폰 선택',
	coupon_entry_label: '쿠폰',
	coupon_available_count: '사용 가능 {count}장',
	coupon_no_use_text: '쿠폰 미사용',
	coupon_best_tag: '최적',
	coupon_expired_text: '만료됨',
	close_text: '닫기',
	discount_coupon_label: '할인 쿠폰',
	coupon_single_use_hint: '주문당 쿠폰 한 장만 사용할 수 있습니다',
	order_amount_text: '상품 금액',
	discount_amount_text: '쿠폰 할인',
	payable_amount_text: '결제 금액',
	coupon_extra_rebate_notice: '추가 50% 리베이트는 우편으로 지급됩니다. 고객센터에 등록을 요청해 주세요.',
	payment_recommended_text: '추천 결제',
	payment_enjoy_rebate: '{pct}% 페이백 혜택',
	payment_order_rebate: '이번 주문 페이백 {amount}',
	payment_order_discount: '이번 주문 할인 {amount}',
	recommend_text: '추천',
	payment_other_methods_text: '기타 결제 수단',
	super_coupon_title: '한정 슈퍼 쿠폰',
	super_coupon_end_time: '이벤트 종료 시간:',
	super_coupon_previous_activity: '이전 슈퍼 쿠폰 이벤트',
	super_coupon_recommended: '추천',
	super_coupon_view_details: '슈퍼 쿠폰 팩 상세 보기',
	super_coupon_value_label: '실제 할인 가치',
	super_coupon_contents: '슈퍼 쿠폰 팩 구성',
	super_coupon_threshold: '{amount}원 이상 구매',
	super_coupon_discount: '{amount} 할인',
	super_coupon_remaining: '남은 시간 {time}',
	super_coupon_purchased: '구매 완료',
	super_coupon_buy_now: '지금 구매',
	super_coupon_next_activity: '다음 슈퍼 쿠폰 이벤트',
	super_coupon_switcher: '슈퍼 쿠폰 이벤트 전환',
	super_coupon_switch_to: '{index}번째 슈퍼 쿠폰 이벤트로 전환',
	super_coupon_details_title: '슈퍼 쿠폰 팩 상세 정보',
	super_coupon_close_details: '슈퍼 쿠폰 팩 상세 정보 닫기',
	super_coupon_empty: '현재 할인 쿠폰이 없습니다',
	super_coupon_instructions: '사용 안내',
	super_coupon_confirm: '확인',
	super_coupon_package_name: '슈퍼 쿠폰 팩',
	super_coupon_get_coupons: '구매 즉시 할인 쿠폰 {count}장 지급',
	super_coupon_reward_multiple: '약 {multiple}배 혜택',
	super_coupon_purchase_limit: '1회 구매 시 {count}세트 한정',
	super_coupon_purchase_interval: '구매 간격 {days}일',
	super_coupon_rule_separator: ', ',
	super_coupon_unknown_status: '알 수 없는 상태',
	super_coupon_date_format: '{year}년 {month}월 {day}일 {time}',
	super_coupon_used: '사용 완료',
	super_coupon_expired: '만료됨',
	super_coupon_unit_day: '일',
	super_coupon_unit_days: '일',
	super_coupon_unit_hour: '시간',
	super_coupon_unit_hours: '시간',
	super_coupon_unit_minute: '분',
	super_coupon_unit_minutes: '분',
	super_coupon_valid_for: '{value}{unit} 동안 유효'
}
